<template>
    <div class="backgroundImage pa-0">

        <v-row justify="center" class="mt-0">
            <v-col cols="12" class="textCenter">
                <v-row justify="center">
                    <v-col><img src="../../assets/imagenes/LogotipoReusapp.svg" alt=""
                            class="textCenter imageLogo" /></v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="isCanceled" justify="center" class="px-5">
            <v-col xl="4" lg="4" md="4" sm="6" cols="12" class="textCenter pt-12">
                <v-row justify="center"><span class="textoFin">Su reserva ha sido cancelada</span></v-row>
                <v-row justify="center"><span class="subFin">Gracias por utilizar Reusapp. Si desea volver a reservar otro
                        producto, entre de
                        nuevo
                        en la
                        aplicación.</span></v-row>
                <v-row justify="center" class="pt-12
                ">
                    <v-col cols="12" class="textCenter logoCancelado">
                        <img class="logoEmulsa" src="../../assets/imagenes/Logotipo.svg" />
                    </v-col>
                </v-row>

            </v-col>

        </v-row>
        <v-row v-if="producto && !isCanceled" justify="center" class="rowPrincipal">
            <v-col col="12" class="textCenter">
                <v-row justify="center">
                    <v-col cols="12">
                        <div v-for="(fotos, index) in producto.fotosProductosReusapp" :key="index">
                            <img v-if="fotos.principal" :src="fotos.urlFichero" alt="" width="200" class="imagenProducto" />
                        </div>
                    </v-col>

                </v-row>
                <v-row justify="center">
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoCampo">Nombre:</v-col>
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoDato">{{ producto.nombre }}</v-col>
                </v-row>
                <v-row justify="center">
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoCampo">Categoría:</v-col>
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoDato">{{ producto.categoria.nombre }}</v-col>
                </v-row>
                <v-row justify="center">
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoCampo">Descripción:</v-col>
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoDato">{{ producto.descripcion }}</v-col>
                </v-row>
                <v-row justify="center">
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoCampo">Estado:</v-col>
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoDato">{{ producto.estado.nombre }}</v-col>
                </v-row>
                <v-row justify="center">
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoCampo">Fecha de Reserva:</v-col>
                    <v-col xl="3" lg="3" md="3" sm="5" cols="9" class="textoDato">{{ fechaProducto }}</v-col>
                </v-row>
                <v-row justify="center" class="pt-6 pb-12">
                    <v-col cols="12">
                        <v-btn large class="ruta" color="primary" @click="openDialog = true">
                            CANCELAR RESERVA
                        </v-btn>
                    </v-col>
                </v-row>


                <v-row class="pt-12">
                    <v-col cols="12" class="textCenter bottomCero">
                        <img class="logoEmulsa" src="../../assets/imagenes/Logotipo.svg" />
                    </v-col>
                </v-row>


            </v-col>
        </v-row>

        <v-dialog v-model="openDialog" class="dialogoDni" width="500">
            <v-card>
                <v-row class="pa-0 ma-0">
                    <v-card-text class="cardDni">
                        <v-col>
                            <v-row justify="center"><v-col class="textCenter">
                                    <h2>¿Desea cancelar su reserva?</h2>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col class="textCenter">
                                    <p>Esta acción es irreversible. Podrá volver a reservar este u otros productos en la
                                        aplicación. Si desea cancelar su reserva introduzca su NIF/NIE.</p>
                                </v-col>
                            </v-row>
                            <v-form v-on:submit.prevent>
                                <v-row>
                                    <v-text-field label="NIF/NIE" required solo v-model="dniCheck"
                                        :rules="inputRule"></v-text-field>
                                </v-row>
                                <v-row justify="center">
                                    <v-col class="textCenter pa-0"><v-btn class="botonVolver"
                                            @click="openDialog = false">Volver Atrás</v-btn></v-col>
                                    <v-col class="textCenter pa-0"><v-btn class="botonEnviar"
                                            @click="cancelarReserva">Cancelar
                                            Reserva</v-btn></v-col>
                                </v-row>
                            </v-form>



                        </v-col>
                    </v-card-text>
                </v-row>


            </v-card>
        </v-dialog>
     

    </div>
</template>

<script>
import router from '@/router';

//import { cancelarReservaStore } from "../../store/cancelarReservaStore/cancelarReservaStore";
export default {
    name: "CancelarReserva",
    data() {
        return {
            isCanceled: false,
            openDialog: false,
            producto: null,
            dniUsuario: null,
            idProducto: null,
            dniCheck: null,
            userToken: null,
            inputRule: [
                v => !!v || 'Campo obligatorio',
                v => /^([0-9]{8}[A-Z])|[XYZ][0-9]{7}[A-Z]$/.test(v) || 'El NIF/NIE debe ser válido'
            ]
        };
    },
    computed: {
        fechaProducto() {
            let dateReserva = new Date(this.producto.fechaReserva).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
            return dateReserva
        }
    },
    async created() {
        this.productoCancelar();

    },
    methods: {
        async productoCancelar() {
            const token = this.$route.params.token
            
            if (!this.isCanceled) {
                try {
                    const productoCancelar = await this.$store.dispatch("ObtenerProductoCancelar/getObtenerProductoCancelar", token)
                    this.producto = productoCancelar.data
                    this.dniUsuario = this.producto.usuarioReusapp.dni
                    this.userToken = token
                } catch (error) {
                    router.push('/')
                }

            }

        },

        async cancelarReserva() {
            try {
                if (this.dniCheck == this.dniUsuario) {
                    let datosCancelar = { dni: this.dniCheck, token: this.userToken }
                    const cancelarReserva = await this.$store.dispatch("ObtenerProductoCancelar/deleteCancelarProducto", datosCancelar)
                    if (cancelarReserva.status == 200) {
                        this.isCanceled = true
                        this.openDialog = false
                    }
                } 
            } catch (error) {
                console.log(error)
            }


        }


    },
}

</script>
<style lang="css">
.v-main {
    max-height: 100% !important;

}

.v-dialog v-dialog--active {
    overflow: hidden !important;
}

.v-dialog {
    overflow: hidden !important;
}
</style>
<style lang="css" scoped>
.logoCancelado {
    position: absolute !important;
    bottom: 3% !important;
}

.textoFin {
    /* padding: 60px 0px 30px !important; */
    font-size: 25px !important;
    font-weight: bold;
    padding-bottom: 10px !important;
}

.subFin {
    font-size: 20px !important;

}

.botonEnviar {
    background-color: #0072B9 !important;
    color: #fff !important;
    border-radius: 20px;
}

.botonVolver {
    background-color: #D83D34 !important;
    color: #fff !important;
    border-radius: 20px;
}

.ruta {
    background-color: #0072B9;
    color: #fff !important;
    width: 230px;
    border-radius: 20px;
    text-transform: capitalize;
    font-size: 18px !important;

}

.v-main {
    max-height: 100% !important;

}

.btnIconoX {

    z-index: 2;

    padding: 5px 0px 0px 10px !important;

}

.textoCampo {
    font-size: 20px !important;
    font-weight: bold !important;
    text-align: right !important;
    padding: 0px 15px 5px 30px !important;
}

.textoDato {

    font-size: 20px !important;
    text-align: left !important;
    padding: 0px 30px 5px 5px !important;

}

.textCenter {
    text-align: center;
}

.imageLogo {

    margin-top: 5vw !important;
    max-width: 270px;
    margin-right: 0.2%;

}

.backgroundImage {
    /* The image used */
    background-image: url("../../assets/imagenes/background_cancel.png");

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 500px !important;
}



.logoEmulsa {

    max-width: 120px;

}


.dialogoDni {
    border-radius: 30px !important;
    overflow: hidden !important;

}

cardDni {
    border-radius: 40px !important;
}

@media only screen and (max-width: 2400px) {

    .bottomCero {
        position: absolute !important;
        bottom: 3% !important;
        text-align: center !important;
        margin-right: 50%;
    }

    .rowPrincipal {
        margin-top: 4vw !important;
    }

}

@media only screen and (max-width: 1700px) {
    .bottomCero {
        position: unset !important;
        /* bottom: 3% !important; */
        text-align: center !important;
        /* margin-right: 50%; */
    }

    .rowPrincipal {
        margin-top: 4vw !important;
    }
}



@media only screen and (max-width: 599.99px) {
    .textoDato {
        padding: unset !important;
        text-align: left !important;
    }

    .textoCampo {
        padding: unset !important;
        text-align: left !important;
    }
}

@media only screen and (max-width: 414px) {

    .botonVolver {
        margin-top: 5px !important;
    }

    .botonEnviar {
        margin-top: 10px;
    }
}
</style>